module.exports = __webpack_public_path__ + "img/builder-24.bc3b3cd6.webp";